// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","316":"b85b1505","455":"55372804","578":"4780cd2b","977":"240addac"}[chunkId] + ".chunk.js";
};